// extracted by mini-css-extract-plugin
export default {"downloadWidgetContainer":"styles_downloadWidgetContainer__O0eS8","downloadWidget":"styles_downloadWidget__DJ8w2"};